var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M42.44 16a11.17 11.17 0 00-9.3 16.63M40.38 8.71a18.59 18.59 0 00-14.51 26M38.34 1.5a26 26 0 00-19.73 35.1M50.82 21.86c-2.28-.32-3.25 1.41-4 2.48S42 31.8 41.36 32.78a3.93 3.93 0 001.06 5.28c2.36 1.89 4.72 3.48-4.14 12.41s-9.65 5.77-11.57 3.42a3.91 3.91 0 00-5.29-1c-1 .65-7.33 4.81-8.39 5.54s-2.79 1.73-2.45 4a11.61 11.61 0 0011 8.08c7.27 0 16.17-5.8 24-13.66S59 40 59 32.77a11.63 11.63 0 00-8.18-10.91z","fill":"none","stroke":"inherit","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"3"}));
}

Phone.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 72 72"};

module.exports = Phone;

Phone.default = Phone;
